import axios from "axios";
import config from "../../../config/config";
import {GetToken} from "../../consultForm/Requests/movistar";

export const deleteCarts =  async (ids:string[]) => {

    type data = {id:string[]};
    let obj:{[key:string]:any} = {result:false};

    let url:string = config.DELETE_CART || '',
        data:data  = {id:ids};
    let {token} = await GetToken();

    try{
      await axios({
            method : "post",
            url    : url,
            data   : data,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization" : `Bearer ${token}`
            }
        })
            .then((resp:any)=>{
                let data = resp.data
                if(data.success){
                    obj.result = true
                    obj.data = resp.data;
                }
            })
            .catch(e=> {
                obj.result   = false
                obj.message  = 'Error intentando eliminar facturas'
            })
    }
    catch (e) {
        obj.result   = false
        obj.message  = 'Error intentando eliminar facturas'
    }

    return obj;
}